import SimpleLightbox from 'simple-lightbox';

class Lightbox {
  constructor(triggerElement) {
    this.trigger = triggerElement;

    this.initial();
  }
  initial() {
    this.addEventlisteners();

    const imageData = this.trigger.getAttribute('data-images');
    this.images = imageData.split(' ');

    const imageCaptions = this.trigger.getAttribute('data-captions');
    if (imageCaptions) {
      this.captions = imageCaptions.split('§');
    }
  }
  addEventlisteners() {
    this.trigger.addEventListener('click', event => {
      event.preventDefault();
      this.openLightbox();
    });
  }
  openLightbox() {
    SimpleLightbox.open({
      items: this.images,
      captions: this.captions
    });
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./src/modules/snippets/lightbox.js